import type {
    GalleryItem,
    MemoryPhotoData,
    OpenWhenLetter,
    QuizQuestion,
    StoryChapter,
    VideoClip
} from '@/types'

// Storage CDN host for this site. It follows the free subdomain, so update it if the subdomain changes.
export const MEDIA_BASE = 'https://happy-birthday-tishu.cdn.modulify.website'

// photo-4, photo-5 and photo-7 are stored sideways, `rotate` turns them upright on screen.
export const PHOTOS = {
    photo1: {
        src: `${MEDIA_BASE}/memories/photo-1.jpg`,
        alt: "Navratri ni raat, Tisha pink dupatta ma ane hu black kurta ma",
        width: 586,
        height: 780,
        rotate: false
    },
    photo2: {
        src: `${MEDIA_BASE}/memories/photo-2.jpg`,
        alt: "Apdi dog filter vali cute selfie",
        width: 720,
        height: 1280,
        rotate: false
    },
    photo3: {
        src: `${MEDIA_BASE}/memories/photo-3.jpg`,
        alt: "Tisha tiranga dupatta ma ane hu ene joto",
        width: 960,
        height: 1280,
        rotate: false,
        position: 'center 15%'
    },
    photo4: {
        src: `${MEDIA_BASE}/memories/photo-4.jpg`,
        alt: "Pehli Navratri ni selfie, Tisha pila chaniya choli ma",
        width: 960,
        height: 1280,
        rotate: true
    },
    photo5: {
        src: `${MEDIA_BASE}/memories/photo-5.jpg`,
        alt: "Tilak lagavi ne apdi festive selfie",
        width: 960,
        height: 1280,
        rotate: true
    },
    photo6: {
        src: `${MEDIA_BASE}/memories/photo-6.jpg`,
        alt: "Farewell na divase Tisha blue saree ma ane hu black blazer ma",
        width: 960,
        height: 1280,
        rotate: false
    },
    photo7: {
        src: `${MEDIA_BASE}/memories/photo-7.jpg`,
        alt: "Tisha mara blazer ma, apdi close selfie",
        width: 960,
        height: 1280,
        rotate: true
    }
} satisfies Record<string, MemoryPhotoData>

export const GATE = {
    title: "Happy Birthday Tisha",
    tagline: "Babudi Tara mate ek bhov special vaatu rakhii chee",
    button: "Tap to open your surprise"
}

export const HERO = {
    eyebrow: "Aj no divas mari dhingli na naam",
    greeting: "Happy Birthday",
    name: "Tisha",
    subtitle: "Tu maraa mate bhovvvvj khass cho madam bhagvan tmnee bhadhii kushiya ape",
    dateTag: "5 Nov",
    countdownTitle: "Tmara birthday ma atloo time baki che",
    todayTitle: "Today is your day",
    units: ["Divas", "Kalak", "Minit", "Second"],
    scrollLabel: "Neeche chalo",
    // 5 November, midnight in India
    birthday: '2026-11-05T00:00:00+05:30'
}

export const STORY: {
    eyebrow: string
    title: string
    subtitle: string
    chapterLabel: string
    chapters: StoryChapter[]
} = {
    eyebrow: "16/12/23",
    title: "Apdi kahani",
    subtitle: "Apdii life no peloo photo che aa",
    chapterLabel: "Chapter",
    chapters: [
        {
            title: "Peli mulaqat yaad che",
            text: "Pelii var joyaa ta tmne khbr ntii kii ajee tme marii maro jiivv bani jaso",
            photo: PHOTOS.photo3
        },
        {
            title: "Pehlii vaat",
            text: "Snapchat thi chaluu thai tii madam khbr che ane hve apdii vatoo purij nthi thatii tmne kidhu tu kii koi kaii pan kee still i lovee you mari jode hji ss pade yo che.",
            photo: PHOTOS.photo2
        },
        {
            title: "Pehli var maleya",
            text: "Hu to tmne kyar no gumto to pan me tmne 12/12/23 joya ta pelii var khbr ntii kii tme mara cho aje",
            photo: PHOTOS.photo1
        },
        {
            title: "Life nu pelo gift",
            text: "Pink and black matching bracelet apyo tu tme hajii che mari jode sach ve lu mara wallet ma thute lu che",
            photo: PHOTOS.photo5
        },
        {
            title: "Ane ajee",
            text: "Tmaruu divas ane huu hamesha mate tmari jode hois tmari sathye hois ane har time ma tmari jode rais",
            photo: PHOTOS.photo7
        }
    ]
}

export const GALLERY: {
    title: string
    subtitle: string
    close: string
    previous: string
    next: string
    items: GalleryItem[]
} = {
    title: "Apdi yaado",
    subtitle: "Ek ek photo sachvii ne rakhya che madam 🥺🥺",
    close: "Band karo",
    previous: "Pichhli photo",
    next: "Agli photo",
    items: [
        {
            photo: PHOTOS.photo6,
            caption: "School farewell time to photo bhou mast mari lagti ti"
        },
        {
            photo: PHOTOS.photo2,
            caption: "Apdi cute selfie"
        },
        {
            photo: PHOTOS.photo3,
            caption: "Apdi life no peloo random photo che apda lagan thai jase ne ye time ye ek moti photo frame rakh su apda ghar ma"
        },
        {
            photo: PHOTOS.photo4,
            caption: "Apdi pehli Navratri"
        },
        {
            photo: PHOTOS.photo7,
            caption: "Tmee maraa choo madamm"
        },
        {
            photo: PHOTOS.photo1,
            caption: "Apdii biji Navratri apde aa Navratri nu to kai nthi"
        },
        {
            photo: PHOTOS.photo5,
            caption: "Tmaro hato tmaro cho ane tmaroj rais"
        }
    ]
}

export const VIDEOS: {
    title: string
    subtitle: string
    film: {
        play: string
        meta: string
        pause: string
        resume: string
        previous: string
        next: string
    }
    clips: {
        title: string
        subtitle: string
        play: string
        count: string
        label: string
        error: string
        items: VideoClip[]
    }
} = {
    title: "Video Memories",
    subtitle: "Apda best photos",
    film: {
        play: "Yaadein play karo",
        meta: "7 pal, ek chhoti si film",
        pause: "Roko",
        resume: "Chalao",
        previous: "Pichhla pal",
        next: "Agla pal"
    },
    clips: {
        title: "Apdi nani nani clips",
        subtitle: "Apdaa bee nii memories che aa too kyaa thi bhulu",
        play: "Clips chalao",
        count: "3 chhoti clips",
        label: "Clip",
        error: "Ye clip abhi chal nahi rahi, thodi der baad try karo.",
        items: [
            { src: `${MEDIA_BASE}/clips/clip-1.mp4` },
            { src: `${MEDIA_BASE}/clips/clip-2.mp4` },
            { src: `${MEDIA_BASE}/clips/clip-3.mp4` }
        ]
    }
}

export const REASONS = {
    eyebrow: "Reasons Why I Love You",
    title: "Bhouu prem karuu choo madam tmne",
    subtitle: "Ek ek card khol har ek reason sacho che kem ki maro prem sacho che 🥺🥺",
    frontLabel: "Reason",
    frontHint: "Tap karo",
    readSuffix: "padh liye",
    flipAll: "Saare ek saath palto",
    doneMessage: "Badha reason to tmne mari jodej malse ena mate too tmne malvu padse madam j",
    items: [
        "Bhou prem karu chu babu tne jiv thi pan vadhre",
        "Sacha dil thi prem laru chu",
        "Sacha dil thi tmari jode lagan kar va che",
        "Nathi chaltu tmara vina mne",
        "Bhouu miss karu hal pan",
        "Mnee tuj joiyee che",
        "Na tara thi saru na tara thi kharab mne khali mari tisha joiye",
        "Tmaro birthday celebrate karvo che but possible nthi tmara mate",
        "Lagan thai jase ne tare mnav su paku maro promise che tne",
        "Tne khota promise nhi karu pan ha efforts kars tara mate",
        "I loveee youu mari dhingli",
        "Happiest birthday mara pyara wifyyy jii ne"
    ]
}

export const LETTER = {
    title: "Ek love letter tmara naam",
    waiting: "Bee min kham jee ho dobi hal lakhii ne duo",
    writing: "Likh raha hoon",
    done: "Dil thi lakhu che madam ignore na mar ta",
    skip: "Poora padho",
    replay: "Pachuu lakhu madam",
    body: "Marii pyarii babuuu happy birthday maraa jivvv nee and thank youu soo much ke tmee mara jivan ma aya mara life ma ayaa madammm i really loveee youuu mara jivvv bhagvan tnee badhii khusii yooo apee ane badhiii wisho purii karee aa marii prathna chee happiest birthday mara dear wifyy jiii neee loveeee youuuuuuu maraaa jiivvvvv ❤️❤️❤️❤️❤️❤️❤️❤️",
    signature: "A Radha no khano"
}

export const SONG = {
    title: "Apduu geet",
    subtitle: "Euo geet yee shabhdtaj tmari yaad avi jaye che",
    name: "Soniyo",
    artist: "Sonu Nigam, Shreya Ghoshal",
    note: "Aa geet jyare pan vage chhe, mane fakt tu j yaad aave chhe. Darak line ma tamaro chehro dekhay chhe, aur darak beat par dil thodu vadhu tamaru thai jay chhe.",
    src: '/audio/soniyo.mp3',
    play: "Gaana chalao",
    pause: "Gaana roko",
    seek: "Gaana kahan tak chala",
    error: "Gaana abhi chal nahi raha, thodi der baad try karo."
}

export const GAMES = {
    title: "Khel, Pyaar aur Surprise"
}

export const WISH = {
    title: "Make a Wish",
    text: "Aankhein band karo, ek wish maango, aur candles phoonk do.",
    mic: "Mic se phoonko",
    listening: "Sun raha hoon, ab phoonko",
    all: "Ek saath phoonko",
    done: "Wish poori hogi, pakka.",
    relight: "Phir se jalao",
    micError: "Mic nahi mila, candles pe tap karke phoonko.",
    candle: "Candle"
}

export const QUIZ: {
    title: string
    counter: string
    next: string
    result: string
    correct: string
    wrong: string
    restart: string
    scoreLabel: string
    messages: {
        perfect: string
        good: string
        low: string
    }
    questions: QuizQuestion[]
} = {
    title: "How well do you know us?",
    counter: "Sawaal",
    next: "Agla sawaal",
    result: "Result dekho",
    correct: "Sahi jawab!",
    wrong: "Arre nahi! Sahi jawab:",
    restart: "Phir se khelo",
    scoreLabel: "Tumhara score",
    messages: {
        perfect: "Perfect! Tumse achha mujhe koi nahi jaanta.",
        good: "Bahut badhiya! Bas thoda aur dhyaan do.",
        low: "Koi baat nahi, mujhe jaanne ke liye poori zindagi padi hai."
    },
    questions: [
        {
            question: "Meri sabse favourite jagah kaunsi hai?",
            options: ["Beach", "Pahad", "Tumhare paas", "Mera bistar"],
            answer: 2
        },
        {
            question: "Main sabse zyada khush kab hota hoon?",
            options: ["Match jeet ke", "Tumhari smile dekh ke", "Khana kha ke", "Chhutti wale din"],
            answer: 1
        },
        {
            question: "Mujhe tumhari kaunsi aadat sabse pyaari lagti hai?",
            options: ["Gussa karna", "Late aana", "Bas 5 minute bolna", "Sab kuch"],
            answer: 3
        },
        {
            question: "Main tumhe din mein kitni baar yaad karta hoon?",
            options: ["Har pal", "Ek baar", "Sirf raat ko", "Das baar"],
            answer: 0
        },
        {
            question: "Hamari kahani ka best chapter kaunsa hai?",
            options: ["Pehli mulaqat", "Pehli chat", "Jo abhi aana baaki hai", "Pehla gift"],
            answer: 2
        }
    ]
}

export const OPEN_WHEN: {
    title: string
    subtitle: string
    open: string
    reopen: string
    close: string
    letters: OpenWhenLetter[]
} = {
    title: "Open when...",
    subtitle: "Aa tare khol jee jyare tne marii vadhre jarurt hoye",
    open: "Kholo",
    reopen: "Phir se padho",
    close: "Band karo",
    letters: [
        {
            title: "Open when you miss me",
            message: "Tmari aakho ban kari ne mne yaad kar je hu hmesha tmari jode cho nakar pillow ne hug kari le je."
        },
        {
            title: "Open when tum sad ho",
            message: "Marii jode avii ne vaat share kar je bass hu shamadis ane tne mnaavis"
        },
        {
            title: "Open when smile chahiye",
            message: "Smile joto hoye to mne joii le jee automatic smile avii jase"
        },
        {
            title: "Open when neend nahi aa rahi",
            message: "Hu chu ne madam tmari made pillow mara upar rest kar jo hu neendr kara vi dais tmari"
        },
        {
            title: "Open when hamari ladai ho",
            message: "Bhool tari hoye ke marii hu tmne hu tne pela sorry kaii dais bas mara bachudaa ane prem ma to jhagdoo to thayej ne"
        },
        {
            title: "Open when tum khud pe doubt karo",
            message: "Pota upar koi divas doubt na kar je ke hu aa nhi kari shaku ke am che tem che i am always with you my babyy ane tme too pela thij hoshiyar choo"
        }
    ]
}

export const PROMISES = {
    title: "Aa varash na promise",
    subtitle: "Aa varash na promise ane efforts",
    button: "Pakka promise",
    items: [
        "Taro sath hu koii divas nhi muku bhle kai pa. Thaii jaye",
        "Bhale gamete vo jhagdo kem na hoye hu pela sorry kai dais bhle mari babudi",
        "Tari har vaat hu manis",
        "Tmara har ek spna hu pura karis support karis",
        "Koi divas tmne eklo muki ne nai jauo",
        "Tmne koi divas udas nhi thava dauo",
        "Bijo birthday avse ne ye apde begha celebrate kar su"
    ]
}

export const FINALE = {
    question: "Will you be mine forever?",
    yes: "Haan, hamesha",
    no: "Nahi",
    yesTitle: "Mne khbr hati",
    yesLine: "Hve thi tme mara cho ane hu tmaro",
    giftMessage: "Tmaro wait rese madam jii call ane msg noo ayo to shmji ki kadr karo cho mara prem ni nhi karo to pan tmara mate mara dil na darvaja hamesha mate khula che prem karta haso to kar so call msg"
}

export const FOOTER = {
    title: "Happy birthday mari tishu baby",
    line: "I lovee youu mara wifyy jii",
    backToTop: "Upar chalo"
}
